<template>
  <div
    :class="[
      selected ? 'bg-blue-100' : 'bg-white',
      'flex flex-row rounded-md border'
    ]"
  >
    <div v-if="photo" class="flex w-1/5">
      <img
        v-if="pack.master_image_url"
        class="flex-grow-0 rounded-l-md object-cover"
        :alt="pack.name"
        style="aspect-ratio: 1/1"
        :src="pack.master_image_url"
      />
      <div
        v-else
        class="flex flex-1 items-center justify-center rounded-l-md bg-gray-500 text-gray-700"
      ></div>
    </div>
    <div class="flex flex-col p-3 pt-2" :class="[photo ? 'w-4/5' : 'w-full']">
      <div class="flex cursor-pointer flex-col gap-1" @click="isOpen = !isOpen">
        <div class="flex flex-row items-center justify-between">
          <h3
            class="capitalize-first flex-1 text-base font-semibold text-gray-700"
          >
            {{ pack.name[$i18n.locale] }}
          </h3>
          <FontAwesomeIcon
            :icon="isOpen ? ['fas', 'chevron-up'] : ['fas', 'chevron-down']"
            class="text-gray-500"
          />
          <!--          <span-->
          <!--            class="flex shrink-0 select-none items-center gap-1 rounded border px-2 text-sm text-gray-700"-->
          <!--          >-->
          <!--            <span class="text-xs">{{ displayPriceType }}</span>-->
          <!--            <span class="font-bold">{{ displayedPrice }}</span>-->
          <!--          </span>-->
        </div>
        <div class="flex flex-row">
          <div class="flex flex-1 flex-col">
            <p v-if="pack.remarks">{{ displayedRemarks }}</p>
          </div>
        </div>
        <div
          v-if="isOpen && pack.items?.length && pack.items?.length > 0"
          class="bg-primary-50 flex flex-col divide-y divide-slate-200 rounded border text-xs"
        >
          <PackItemModalCard
            v-for="(item, index) in pack.items"
            :key="index"
            :item="item"
            :price-encoding-type="initialMetadata.settings.price_encoding_type"
          />
        </div>
        <div class="flex flex-row items-center">
          <div class="flex flex-1 flex-row justify-end">
            <div
              v-if="selected"
              class="flex shrink-0 flex-row items-center text-green-600"
            >
              <FontAwesomeIcon :icon="['fas', 'circle-check']" size="lg" />
            </div>
            <BaseButton
              :title="$t('button.add')"
              icon="plus"
              size="extra-small"
              :disabled="disableButtons || isSubmitting"
              :display-loader="disableButtons"
              @click.stop="handleSelection(pack)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PackItemModalCard from '@ui/modal/item/components/components/PackItemModalCard'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'PackModalCard',
  components: { FontAwesomeIcon, BaseButton, PackItemModalCard },
  props: {
    pack: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: false,
      default: false
    },
    photo: {
      type: Boolean,
      required: false,
      default: false
    },
    disableButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['selection'],
  data() {
    return {
      isOpen: false,
      isSubmitting: false
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata'
    }),
    displayedRemarks() {
      if (this.pack.remarks[this.$i18n.locale])
        return this.pack.remarks[this.$i18n.locale]
      if (typeof this.pack.remarks === String) return this.pack.remarks
      return null
    },
    displayedPrice() {
      if (this.initialMetadata.settings.price_encoding_type === 'HTVA') {
        return this.$h.formatCurrency(
          this.pricePackSum('price_htva', Object.values(this.pack.items))
        )
      } else if (this.initialMetadata.settings.price_encoding_type === 'TVAC') {
        return this.$h.formatCurrency(
          this.pricePackSum('price_tvac', Object.values(this.pack.items))
        )
      }
      return null
    },
    displayPriceType() {
      if (this.initialMetadata.settings.price_encoding_type === 'HTVA') {
        return this.$t('global.excluding_vat').toUpperCase()
      } else if (this.initialMetadata.settings.price_encoding_type === 'TVAC') {
        return this.$t('global.tax_included').toUpperCase()
      }
      return null
    }
  },
  methods: {
    // handleSelection(pack) {
    //   this.$emit('selection', { pack: pack })
    // },
    async handleSelection(pack) {
      if (this.isSubmitting) return
      this.isSubmitting = true

      await this.$emit('selection', { pack: pack })

      setTimeout(() => {
        this.isSubmitting = false
      }, 500)
    },
    pricePackSum(type, items) {
      return items
        .reduce((accumulator, item) => {
          return (
            accumulator +
            item[type] * (1 - item.reduction / 100) * item.quantity
          )
        }, 0)
        .toFixed(2)
    }
  }
}
</script>
